module.exports = __webpack_public_path__ + "static/media/open-book.38bd7731.png";